import React, { FC } from "react";
import { SavedOption } from "../SavedOption";
import { ShippingAddress } from "v3/services/graphql/generated";

interface ShippingMethodOptionProps {
  checked: boolean;
  isDefault?: boolean;
  name: string;
  description: string;
  onSelect: () => void;
  price: string;
  distance?: string;
  checkpoint?: string;
  address?: ShippingAddress;
  showPhoneForm?: boolean;
}

export const ShippingMethodOption: FC<ShippingMethodOptionProps> = ({
  checked = false,
  isDefault = false,
  name,
  description,
  onSelect,
  price,
  distance,
  checkpoint,
  address,
}) => {
  return (
    <SavedOption
      checked={checked}
      handleClick={onSelect}
      isDefault={isDefault}
      title={name}
      distance={distance}
      description={description}
      checkpoint={checkpoint}
      rightAlignedContent={price}
      address={address}
    />
  );
};
